<template>
  <div class="cs-product">
    <div class="cs-product-first-wrapper">
      <div class="cs-product-image">
        <img :src="productImage">
        <div
          class="cs-remove-btn"
          @click="removeItem"
        >
          Remover
        </div>
      </div>

      <div class="cs-product-info">
        <div class="cs-product-name">
          <strong>
            {{ product.name }}
          </strong>
        </div>
        <p class="cs-product-description">
          {{ product.description }}
        </p>
      </div>
    </div>

    <div class="cs-product-second-wrapper">
      <div class="cs-product-quantity">
        <div class="cs-product-quantity-input">
          <button
            class="cs-subtract-quantity"
            @click="updateQuantity(-1)"
          >
            -
          </button>
          <input
            v-model="quantity"
            type="number"
            required
            @keydown.prevent
          >
          <button
            class="cs-add-quantity"
            @click="updateQuantity(1)"
          >
            +
          </button>
        </div>
        <p>{{ maxQuantity }} disponíveis</p>
      </div>
      <div class="cs-product-price">
        R$ {{ quantityPrice }}
      </div>
    </div>
  </div>
</template>

<script>
let CartItem = {
  name: 'CartItem',

  props: {
    cartItem: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      defaultImageSrc: require('@/assets/icons/empty_product_image.png'),
      maxQuantityDefault: 99,
      quantity: this.cartItem.quantity
    }
  },

  computed: {
    maxQuantity() {
      return this.product.manageStock ?
        getQuantity(this.product, this.cartItem.variationId) :
        this.maxQuantityDefault
    },

    product() {
      return this.cartItem.product
    },

    productImage() {
      let photo = this.product.photos[0]

      return photo ? photo.settings.thumbnails.small.src : this.defaultImageSrc
    },

    quantityPrice() {
      let cartItemPrice = this.product.offerPrice || this.product.price,
        quantityPrice = parseFloat(cartItemPrice) * this.quantity

      return quantityPrice.toFixed(2).replace('.', ',')
    }
  },

  methods: {
    updateQuantity(amount) {
      let updatedQuantity = this.quantity + amount

      if (isValid(updatedQuantity, this.maxQuantity)) {
        this.quantity = updatedQuantity
        this.updateItem()
      }
    },

    removeItem() {
      cleanShipping(this.product, this.$store)
      this.$store.dispatch('cart/removeCartItem', this.cartItem.id)
    },

    updateItem() {
      this.$store.dispatch('cart/updateCartItem', {
        id: this.cartItem.id,
        quantity: parseInt(this.quantity)
      })
    }
  },

  watch: {
    quantity(quantity, _) {
      cleanShipping(this.product, this.$store)
    }
  }
}

function isValid(quantity, maxQuantity) {
  return quantity >= 1 && quantity <= maxQuantity
}

function getQuantity(product, variationId) {
  return variationId ?
    product.variations.find(variation => variation.id == variationId).quantity :
    product.quantity
}

function cleanShipping(product, store) {
  product.requiresShipping && store.dispatch('shipping/clean')
}

export default CartItem
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_mixins.scss';

%cs-font-style {
  color: #666;
  font-family: 'OpenSans-Regular', 'Open Sans';
  font-style: normal;
  font-weight: 400;
}

input[type=number] {
  -moz-appearance:textfield;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin: 0;
  }
}

.cs-product {
  display: flex;
  flex-wrap: wrap;
  padding: 2%;

  .cs-product-first-wrapper {
    @include phone-only { width: 100%; margin: 2% 0; }
    @include tablet-portrait-up { width: 65%; }
    @include tablet-landscape-up { width: 75%; }
    display: flex;
    align-items: center;

    .cs-product-image {
      margin-right: 2%;

      img {
        border-radius: 50%;
        height: 68px;
        width: 68px;
      }

      .cs-remove-btn {
        @extend %cs-font-style;
        color: #000;
        cursor: pointer;
        font-size: 12px;
        text-decoration: underline;
      }
    }

    .cs-product-info {
      text-align: left;
      font-size: 14px;

      .cs-product-name, .cs-product-description {
        overflow: hidden;
      }

      .cs-product-description {
        @extend %cs-font-style;
        width: 95%;
        white-space: pre-line;
        margin: 0;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
      }
    }
  }

  .cs-product-second-wrapper {
    @include phone-only { width: 100%; margin: 5% 0; }
    @include tablet-portrait-up { width: 35%; }
    @include tablet-landscape-up { width: 25%; }
    display: flex;
    justify-content: space-between;
    align-items: center;

    .cs-product-quantity {
      .cs-product-quantity-input {
        display: flex;
        align-items: center;
        border: 1px solid #ccc;
        border-radius: 4px;
        justify-content: center;

        input {
          font-size: 16px;
          height: 40px;
          text-align: center;
          border: 0;
          color: #333;
          width: 40px;
          padding: 0;
          outline: none;
        }

        button {
          cursor: pointer;
          background-color: unset;
          border: 0;
          font-size: 25px;
          outline: none;
        }

        .cs-add-quantity {
          color: #169BD5;
        }

        .cs-subtract-quantity {
          color: #666;
        }
      }

      p {
        @extend %cs-font-style;
        font-size: 12px;
        margin-bottom: 0;
      }
    }

    .cs-product-price {
      margin-bottom: 8%;
    }
  }
}
</style>
